// Debug function to test browser notifications directly
export const debugNotification = async () => {
  
  // 1. Check if notifications are supported
  if (!('Notification' in window)) {
    return;
  }
  
  // 2. Check current permission
  
  // 3. Request permission if needed
  if (Notification.permission === 'default') {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return;
    }
  } else if (Notification.permission === 'denied') {
    return;
  }
  
  // 4. Create notification
  try {
    const notification = new Notification('🔔 Debug Notification', {
      body: 'If you see this, browser notifications are working!',
      tag: 'debug-' + Date.now(),
      renotify: true,
      requireInteraction: false
    });
    
    notification.onshow = () => {
    };
    
    notification.onerror = (error) => {
    };
    
    notification.onclick = () => {
      window.focus();
      notification.close();
    };
    
    
    // Also trigger the Echo notification manually
    window.dispatchEvent(new CustomEvent('echo:notification', { 
      detail: {
        title: 'Manual Echo Test',
        body: 'Testing Echo notification flow',
        type: 'info',
        source: 'manual-debug'
      }
    }));
    
    return notification;
  } catch (error) {
    return false;
  }
};

// Make it globally available for testing
if (typeof window !== 'undefined') {
  window.debugNotification = debugNotification;
}